define(
    'viewmodels/secured/explorer/navigation/search/search',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "services/session",
        "viewmodels/secured/explorer/navigation/menu",
        "i19n!i19n/strings"
    ],
    function (ctx, ViewModel, dataProvider, session, menu, i19n) {
        var cboLibrary;
        var cboFilter;
        var txtFilter;
        var cboCreatedModified;
        var cboReview;

        var vm = new ViewModel({
            i19n: i19n,
            
            menu: menu,
            searchMenuItem: new menu.Item(true, 'search'),

            libraryId: ko.observable(''),
            library: ko.observable(''),
            criteria: ko.observable(''),
            criteriaHint: ko.observable('Leave blank or enter text/number'),

            by: ko.observable(''),

            allFileType: ko.observable(true),
            fileTypeIds: ko.observableArray([]),

            emailAttachmentTypes: ko.observableArray([{ id: '-1', text: 'or without', isSelected: ko.observable(true) }, { id: '1', text: 'one or more', isSelected: ko.observable(false) }, { id: '0', text: 'no', isSelected: ko.observable(false) }]),
            emailAttachmentType: ko.observable({ id: '-1', text: 'or without', isSelected: ko.observable(true) }),

            allDocumentStatus: ko.observable(true),
            documentStatusIds: ko.observableArray([]),

            dateRangeFromTo: ko.observable('a'),
            dateRangeFrom: ko.observable(''),
            dateRangeTo: ko.observable(''),

            dateReviewFromTo: ko.observable('a'),
            dateReviewFrom: ko.observable(''),
            dateReviewTo: ko.observable(''),

            nextReviewBy: ko.observable(''),

            showEmailFileType: ko.observable(false),
            emailFrom: ko.observable(''),
            emailTo: ko.observable(''),

            data: null,

            isBusy: ko.observable(false),
            mode: ko.observable("simple"),

            isFavoriteSearchFieldAll: ko.observable(false),
            isFavoriteSaved: ko.observable(false),

            savedSearchId: ''
        });

        vm.menu.items().push(vm.searchMenuItem);
        vm.searchMenuItem.isBusy = ko.computed(function () {
            return false;
        });
        vm.searchMenuItemShow = ko.computed(function () {
            var isSelected = vm.searchMenuItem.isSelected();
            if (isSelected) {
                $('#explorer-navigation').css('overflow', 'hidden');
            } else {
                setTimeout(function () {
                    $('#explorer-navigation').css('overflow', 'auto');
                }, 500);
            }

            return isSelected;
        });

        vm.activate = function () {
            vm.mode("simple");            

            return dataProvider.search
                .getDisplay()
                .done(function (data) {
                    vm.data = data;

                    var all = _.find(vm.data.libraries, function (itm) { return itm.libraryId == null; });

                    all.name = 'All Libraries';
                    all.libraryId = '';
                    all.personId = '';

                    //var nextReviewBy = _.find(vm.data.persons, function (itm) { return itm.personId == null; });

                    var hasFavorite = false;
                    _.map(vm.data.advancedDocumentSearchFields, function (itm) {
                        itm.isFavorite = ko.observable(itm.isFavourite);
                        itm.value = ko.observable("");
                        itm.isVisible = ko.observable(true);                                                

                        hasFavorite = itm.isFavorite() || hasFavorite;

                        itm.isHidden = ko.observable(itm.fieldName == "IsTextSearchable");

                        return itm;
                    });
                    vm.isFavoriteSearchFieldAll(hasFavorite);
                    _.map(vm.data.advancedDocumentSearchFields, function (itm) {
                        if (hasFavorite) {
                            itm.isVisible(itm.isFavorite());
                        }

                        return itm;
                    });
                })
                .fail(function (e) {
                });
        };
        vm.attached = function () {
            //vm.fieldList(vm.data.documentSearchFields);
            $(".search-fields-collapsible").hide();

            //dataProvider.search
            //.getFieldList()
            //.done(function (data) {
            //    vm.fieldList(data);
            //    $(".search-fields-collapsible").hide();
            //})
            //.fail(function () {
            //});

            $('#search-filter-txt').on("keyup", function (e) {                
                if (e.keyCode == 13) {
                    vm.criteria($(this).val());
                    vm.searchClick();
                    e.preventDefault();
                }
                return true;
            });
            $('.search-advance-fields').on("keyup", function (e) {
                if (e.keyCode == 13) {
                    vm.searchClick();
                    e.preventDefault();
                }
                return true;
            });

            cboLibrary = $("#search-filter-library-cbo").kendoDropDownList({
                dataTextField: "text",
                dataValueField: "value",
                dataSource: {
                    transport: {
                        read: function (callbacks) {
                            var data = _.map(vm.data.libraries, function (itm) { return { value: itm.libraryId, text: itm.name }; });

                            callbacks.success(data);
                        }
                    }
                },
                change: function (e) {
                    //var d = this.dataItem();
                    
                    //vm.criteriaHint('search ' + d.text);
                }
            }).data("kendoDropDownList");
            
            //cboLibrary.list.width(200);

            cboCreatedModified = $("#search-filter-createdmodifed-cbo").kendoComboBox({
                dataTextField: "text",
                dataValueField: "value",
                dataSource: {
                    transport: {
                        read: function (callbacks) {
                            var data = _.map(vm.data.persons, function (itm) { return { value: itm.id, text: itm.displayName }; });

                            callbacks.success(data);
                        }
                    }
                }
            }).data("kendoComboBox");

            cboReview = $("#search-filter-reviewby-cbo").kendoComboBox({
                dataTextField: "text",
                dataValueField: "value",
                dataSource: {
                    transport: {
                        read: function (callbacks) {
                            var data = _.map(vm.data.persons, function (itm) { return { value: itm.id, text: itm.displayName }; });

                            callbacks.success(data);
                        }
                    }
                }
            }).data("kendoComboBox");

            $('#search-filter-daterangefrom').kendoDatePicker();
            $('#search-filter-daterangeto').kendoDatePicker();
            $('#search-filter-datereviewfrom').kendoDatePicker();
            $('#search-filter-datereviewto').kendoDatePicker();

            vm.resetClick();

            //$("#search-mode-switch").kendoMobileSwitch({
            //    offLabel: "off",
            //    onLabel: "on",
            //    change: function () {
            //        if (this.value()) {
                        
            //        } else {
                                                
            //        }
            //    }
            //});
        };

        vm.clickFavoriteSearchField = function (itm) {            
            itm.isFavorite(!itm.isFavorite());

            dataProvider.search
            .saveFavoriteField({ fieldName: itm.fieldName, fieldValue: itm.isFavorite() })
            .done(function (data) {

            })
            .fail(function (e) {
                console.error(e);
            });
        };
        vm.clickFavoriteSearchFieldAll = function () {
            vm.isFavoriteSearchFieldAll(!vm.isFavoriteSearchFieldAll());

            _.map(vm.data.advancedDocumentSearchFields, function (itm) {
                if (!vm.isFavoriteSearchFieldAll())
                    itm.isVisible(true);
                else
                    itm.isVisible(itm.isFavorite());
            });
        };
        vm.showMoreFieldsClick = function () {
            if($(".search-fields-collapsible").is(":visible"))
                $(".search-fields-collapsible").hide();
            else
                $(".search-fields-collapsible").show();
        };
        vm.searchClick = function () {
            initExplorerContext();

            vm.isBusy(true);
            vm.isFavoriteSaved(false);
            vm.savedSearchId = '';

            var name = 'Search ' + getCurrentTimeFormatted();

            var d = composeSearch(name);
            var search = { q: d };

            search.id = ko.observable('00000000-0000-0000-0000-000000000000');
            search.savedSearchId = '00000000-0000-0000-0000-000000000000';
            search.savedSearchName = ko.observable(name);
            search.label = ko.observable(name);
            search.path = ko.observable("");
            search.isFavourite = ko.observable(false);
            search.removeSearch = ko.observable(null);
            search.query = _toQueryString(d);

            search.label.subscribeChanged(function (newLabel, oldLabel) {
                if (newLabel == "" || newLabel == null)
                    search.label(oldLabel);
            });
            search.removeSearch.subscribe(function (p) {
                if (!p.toggle)
                    vm.savedSearchId = p.savedSearchId;
            });
            search.isFavourite.subscribeChanged(function (n, o) {
                if (vm.savedSearchId != '')
                    search.isFavourite(true);
            });

            ctx.onNavSearch(search);

            setTimeout(function () {
                vm.isBusy(false);
            }, 1000);            
        };
        vm.resetClick = function () {
            vm.isBusy(false);
            vm.criteria('');
            vm.isFavoriteSaved(false);

            reset();
        };
        vm.libraryClick = function (e) {
            vm.libraryId(e.libraryId);
            vm.library(e.name);
            vm.criteriaHint('search ' + e.name);

            return false;
        };
        vm.allFileTypeClick = function (e) {
            if (vm.allFileType()) {
                vm.showEmailFileType(false);
                vm.emailFrom('');
                vm.emailTo('');
                vm.fileTypeIds([]);

            } else {

                vm.allFileType(true);
                vm.fileTypeIds([]);

                return false;
            }

            return true;
        };
        vm.fileTypeClick = function (e) {
            vm.allFileType(false);

            return true;
        };
        vm.allDocumentStatusClick = function (e) {
            vm.allDocumentStatus(false);

            return true;
        };
        vm.documentStatusClick = function (e) {
            vm.allDocumentStatus(false);

            return true;
        };
        vm.emailFileTypeClick = function () {
            vm.showEmailFileType(!vm.showEmailFileType());
            vm.allFileType(false);

            return true;
        };
        vm.emailWithClick = function (e) {
            vm.emailAttachmentTypes()[0].isSelected(false);
            vm.emailAttachmentTypes()[1].isSelected(false);
            vm.emailAttachmentTypes()[2].isSelected(false);

            e.isSelected(true);

            vm.emailAttachmentType(e);

            return false;
        };
        vm.simpleModeClick = function () {
            vm.mode("advanced");
            $('.search-advance-fields').off("keyup", "**");
            $('.search-advance-fields').on("keyup", function (e) {
                if (e.keyCode == 13) {
                    vm.searchClick();
                    e.preventDefault();
                }
                return true;
            });
        };
        vm.advancedModeClick = function () {
            vm.mode("simple");
            $('#search-filter-txt').off("keyup", "**");
            $('#search-filter-txt').on("keyup", function (e) {
                if (e.keyCode == 13) {
                    vm.criteria($(this).val());
                    vm.searchClick();
                    e.preventDefault();
                }
                return true;
            });
        };

        return vm;

        function reset() {
            vm.criteriaHint('Leave blank or enter text/number');
            
            vm.libraryId('');
            vm.library('All Libraries');

            vm.by('');
            
            if (vm.data.documentSearchFields.length > 1) {
                $(".search-fields-checkbox").prop("checked", "");

                _.map(vm.data.documentSearchFields, function (itm) { itm.isDefault = false; });
                $($(".search-fields-checkbox")[0]).prop("checked", "true");
                $($(".search-fields-checkbox")[1]).prop("checked", "true");
                vm.data.documentSearchFields[0].isDefault = true;
                vm.data.documentSearchFields[1].isDefault = true;

                $(".search-fields-collapsible").hide();
            }
            if (vm.data.advancedDocumentSearchFields.length > 1) {
                _.map(vm.data.advancedDocumentSearchFields, function (itm) {

                    itm.value("");

                    return itm;
                });
            }

            vm.allFileType(true);
            vm.fileTypeIds([]);
            vm.emailAttachmentType(vm.emailAttachmentTypes()[0]);

            vm.allDocumentStatus(true);
            vm.documentStatusIds([]);

            vm.dateRangeFromTo('a');
            vm.dateRangeFrom('');
            vm.dateRangeTo('');

            vm.dateReviewFromTo('a');
            vm.dateReviewFrom('');
            vm.dateReviewTo('');

            vm.nextReviewBy('');

            vm.showEmailFileType(false);
            vm.emailFrom('');
            vm.emailTo('');

            cboLibrary.select(0);
            cboCreatedModified.select(0);
            cboReview.select(0);
        }
        function composeSearch(name) {
            var libraryId = vm.libraryId() || "";
            var by = vm.by() ? "&searchPersonId=" + vm.by() : "";
            var savedSearchName = "&savedSearchName=" + encodeURI(name);
            var searchterm = "";
            var documentFields = "";
            var filetypes = ""; 
            var docstatuses = "";
            var daterange = ""; 
            var datereview = "";
            var nextreviewby = "";
            var emailfromto = ""; 
            var emailWithAttachment = "";

            if (vm.mode() == 'simple') {
                searchterm = vm.criteria() ? '&searchterm=' + vm.criteria() : "";

                var filtered = _.filter(vm.data.documentSearchFields, function (itm) { return itm.isDefault; });
                _.map(filtered, function (itm) { documentFields = '&documentFieldId=' + itm.documentFieldId + '' + documentFields; });
            }
            if (vm.mode() == 'advanced') {
                var filtered = _.filter(vm.data.advancedDocumentSearchFields, function (itm) { return itm.value() != ''; });
                _.map(filtered, function (itm) {
                    var ss = itm.value().split(';');
                    if (ss.length > 0) {
                        for (var i = 0; i < ss.length; i++) {
                            documentFields = '&' + itm.fieldName + '=' + ss[i] + '' + documentFields;
                        }
                    } else {
                        documentFields = '&' + itm.fieldName + '=' + itm.value() + '' + documentFields;
                    }
                });
            }
            
            _.map(vm.fileTypeIds(), function (itm) { filetypes = '&filetypeid=' + itm + '' + filetypes; });
            _.map(vm.documentStatusIds(), function (itm) { docstatuses = '&documentControlStatus=' + itm + '' + docstatuses; });

            daterange = vm.dateRangeFromTo() == 'b' ? ('&dateRangeFrom=' + kendo.toString(kendo.parseDate(vm.dateRangeFrom()), "yyyy-MM-dd") + '&dateRangeTo=' + kendo.toString(kendo.parseDate(vm.dateRangeTo()), "yyyy-MM-dd")) : '&dateRangeDays=' + getDateDays(vm.dateRangeFromTo());
            datereview = vm.dateReviewFromTo() == 'b' ? ('&dateReviewFrom=' + kendo.toString(kendo.parseDate(vm.dateReviewFrom()), "yyyy-MM-dd") + '&dateReviewTo=' + kendo.toString(kendo.parseDate(vm.dateReviewTo()), "yyyy-MM-dd")) : '&dateReviewDays=' + getDateDays(vm.dateReviewFromTo());

            nextreviewby = vm.nextReviewBy() ? '&nextReviewBy=' + vm.nextReviewBy() : "";
            emailfromto = (vm.emailFrom() ? '&emailfrom=' + vm.emailFrom() : "") + (vm.emailTo() ? '&emailto=' + vm.emailTo() : "");
            emailWithAttachment = (vm.emailAttachmentType().id == '-1' ? '' : (vm.emailAttachmentType().id == '1' ? 'true' : 'false'));
            emailWithAttachment = emailWithAttachment ? '&IsWithAttachments=' + emailWithAttachment : "";

            return {
                savedSearchName: savedSearchName,
                libraryId: libraryId,
                searchterm: searchterm,
                documentFieldId: documentFields,
                emailWithAttachment: emailWithAttachment,
                emailfromto: emailfromto,
                docstatuses: docstatuses,
                daterange: daterange,
                datereview: datereview,
                nextreviewby: nextreviewby,
                by: by,
                filetypes: filetypes
            };
        }        
        function getDateDays(d) {
            //trap b (between) before calling this

            if(d == 't')
                return '0';
            if(d == '7d')
                return '-7';
            if(d == '90d')
                return '-90';
            if (d == '12m')
                return '-365';

            return 'null';
        }
        function getCurrentTimeFormatted() {
            var d = new Date();
            var o = {year: 'numeric', month: 'long', day:'numeric', hour:'numeric', minute: 'numeric'};
            var a = d.toLocaleString(localStorage.getItem('culture'), o);

            return a;
        }
        function _toQueryString(d) {
            var s = "?libraryId={libraryId}{searchterm}{by}{emailfromto}{emailWithAttachment}{docstatuses}{documentfieldId}{daterange}{datereview}{nextreviewby}{filetypes}{savedSearchName}";

            s = s.replace('{libraryId}', d.libraryId);
            s = s.replace('{searchterm}', d.searchterm);
            s = s.replace('{by}', d.by);
            s = s.replace('{filetypes}', d.filetypes);
            s = s.replace('{emailfromto}', d.emailfromto);
            s = s.replace('{emailWithAttachment}', d.emailWithAttachment);
            s = s.replace('{docstatuses}', d.docstatuses);
            s = s.replace('{documentfieldId}', d.documentFieldId);
            s = s.replace('{daterange}', d.daterange);
            s = s.replace('{datereview}', d.datereview);
            s = s.replace('{nextreviewby}', d.nextreviewby);
            s = s.replace('{savedSearchName}', d.savedSearchName);

            return s;
        }
        function initExplorerContext() {
            if (ctx.current.library) {
                ctx.saveState(ctx.current.library.libraryId, ctx.current);                
            }

            ctx.current = ctx.loadState(null);

            //ctx.onNavFolder(null);
        }
    });
